"use client";

import { cn } from "@jesus-central-church/shared";
import React from "react";

/**
 * Section component - consistent vertical rhythm
 *
 * Spacing system (mobile-first, industry standard):
 * - Section padding: py-12 md:py-16 lg:py-20 (48px → 64px → 80px)
 * - Container padding: px-4 sm:px-6 lg:px-8
 * - Inner spacing: space-y-8 md:space-y-10 lg:space-y-12
 */
export function Section({
  backgroundColor,
  color,
  children,
  className,
  ...additionalProperties
}: {
  backgroundColor: string;
  color?: string;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
  children: React.ReactNode;
}) {
  return (
    <section
      className={cn(
        "relative overflow-hidden",
        `bg-${backgroundColor}`,
        `text-${color}`,
        // Standard section padding: 48px → 64px → 80px
        "py-12 md:py-16 lg:py-20",
        className,
      )}
      {...additionalProperties}
    >
      <div className="mx-auto max-w-7xl space-y-8 px-4 sm:px-6 md:space-y-10 lg:space-y-12 lg:px-8">
        {children}
      </div>
    </section>
  );
}
